import React from 'react'

function BlankWrapper ({ children }) {
  return (<div className="min-h-full">
    {children}
  </div>);
};

export default BlankWrapper;
